import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/component/auth/model/user.model';
import { Node } from 'src/app/component/node/model/node.model';
import { NodesService } from 'src/app/component/node/service/nodes.service';
import { LOGINDETAILS } from 'src/app/component/system/accounts/model/login-audit';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { WorkflowStateTypes } from '../../model/Workbench-dataview';

@Component({
  selector: 'app-change-node',
  templateUrl: './change-node.component.html',
  styleUrl: './change-node.component.scss'
})
export class ChangeNodeComponent implements OnInit {
  frmChangeNodeState: FormGroup;
  node: Node;
  loadingUsers: boolean = false;
  loadingStates: boolean = false;
  assigning: boolean = false;
  currentUser: User;
  chosenEditor: LOGINDETAILS;
  currentEditor: User | any;
  users: User[] = [];
  states?: WorkflowStateTypes | any;
  workflowStateTypes?: WorkflowStateTypes | any;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ChangeNodeComponent>,
    private nodeservice: NodesService, private loginTokenService: LoginTokenService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.frmChangeNodeState = this.fb.group({
      frmChosenState: [''],
      frmChosenEditor: ['']
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.node = this.data;
      this.getWorkflowStates();
    }
  }

  getWorkflowStates() {
    this.loadingStates = true;
    this.nodeservice.getWorkflowStates(this.node).subscribe({
      next: (res) => {
        if (res?.states) {
          this.states = res.states;
          this.loadingStates = false;
        }
      },
      error: (err) => {
        //this.msg = { SUCCESS: false, MSG: 'Error retrieving users.' };
      },
      complete: () => {
        //do nothing
      }
    });
  }

  loadUsersForSelectedState() {
    this.getUsersByRegion();
    this.assigning = true;
  }

  getUsersByRegion() {
    this.loadingUsers = true;
    if (this.states) {
      const matchedState = this.states.find(
        (state: { ID: any; }) => state.ID === this.frmChangeNodeState.get('frmChosenState')?.value
      );
      if (matchedState) {
        this.workflowStateTypes = matchedState;
      }
    }
    this.nodeservice.getUsersInMyRegion(this.node, this.workflowStateTypes).subscribe({
      next: (res) => {
        if (res?.users) {
          this.users = res.users;
          this.loadingUsers = false;
        }
      },
      error: (err) => {
        //this.msg = { SUCCESS: false, MSG: 'Error retrieving users.' };
      },
      complete: () => {
        //do nothing
      }
    });
  }

  trackByUserId(index: number, user: any) {
    return user.ID;
  }

  closeWindow() {
    this.dialogRef.close();
  }

  changeAssign(event: any): void {
    const foundUser = this.users.find(user => user.USER_ID === this.frmChangeNodeState.get('frmChosenEditor')?.value);
    if (foundUser) {
      this.currentEditor = foundUser;
    }
  }

   changeNodeState(): void {
    this.nodeservice.changeNodeState(this.node, this.workflowStateTypes, this.currentEditor, '').subscribe({
      next: (res) => {
        if (res?.msg?.SUCCESS && res?.nodeEditor) {
          this.currentUser = this.loginTokenService.getUser();
          if (this.currentUser)
            if (this.currentUser.ID === this.node?.NODE_EDITING?.[0]?.LOGIN_DETAILS?.ID) {
              //this.workbenchBadges.updateAllCount();
            }
          if (this.node?.NODE_EDITING?.length) {
            this.node.NODE_EDITING[0] = res.nodeEditor;
          } else {
            this.node.NODE_EDITING = [res.nodeEditor];
          }
        }
        else if (res?.msg?.SUCCESS === false) {
          //do nothing
        }
        else {
          //do nothing
        }
      
      },
      error: (err) => {
        //this.msg = { SUCCESS: false, MSG: 'Error retrieving users.' };
      },
      complete: () => {
        //do nothing
      }
    });
    this.closeWindow();
  }
  
}